module.exports = __webpack_public_path__ + "static/media/collaborate.5718a791.gif";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/git-more-done/assets/collaborate.gif
// module id = 399
// module chunks = 0